<template>
    <div class="slider-container" @touchstart="startSwipe" @touchmove="moveSwipe" @touchend="endSwipe">
      <div class="tariff-block" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div v-for="(card, index) in cards" :key="index" class="tariff-card">
          <div class="tariff-card__header">{{ card.header }}</div>
          <div v-if="compareDateToNow(card.activeUntil)" class="tariff-card__parameters">
            <div class="row">{{ card.type }}</div>
            <div class="row">
              <div>{{ card.speed }}</div>
              <div>{{ card.unit }}</div>
            </div>
            <div class="row">
              <div>{{ $t('tariffSlider.price') }}</div>
              <div class="property-block">
                <div>{{ card.cost }}</div>
                <div>{{ $t('tariffSlider.currency') }}</div>
              </div>
            </div>
            <div class="row">
              <div>{{ $t('tariffSlider.activeTo') }}</div>
              <div>{{ card.activeUntil }}</div>
            </div>
          </div>
          <div v-else class="tariff-card__parameters-locked">
            <div class="row">
              <div>{{ $t('tariffSlider.price') }}</div>
              <div class="property-block">
                <div>{{ card.cost }}</div>
                <div>{{ $t('tariffSlider.currency') }}</div>
              </div>
            </div>
            <div class="row">
              <div>{{ $t('tariffSlider.activeTo') }}</div>
              <div>{{ card.activeUntil }}</div>
            </div>
          </div>
          <!-- access-blocked-banner.svg -->
          <div>
            <img v-if="compareDateToNow(card.activeUntil)" src="@/assets/icons/specials/tariff-card.svg"  />
            <img v-else-if="locale == 'en'" src="@/assets/images/access-blocked-banner.svg" alt="" srcset="">
            <img v-else-if="locale == 'ua'" src="@/assets/images/access-blocked-banner-ukr.svg" alt="" srcset="">
          </div>
        </div>
      </div>

      <div class="navigation">
        <div
          v-for="(card, index) in cards"
          :key="index"
          class="navigation__square"
          :class="{ open: index === currentIndex }"
          @click="changeSlide(index)"
        ></div>
      </div>
    </div>
  </template>

<script>
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  function parseDate(str) {
    const [day, month, year] = str.split('.').map(Number);
    return new Date(year, month - 1, day); // Нумерація місяців у JS починається з 0
  }

  export default {
    props: {
      cards: {
        type: Array,
        required: true,
        default: () => [],
      },
    },

    setup(props) {
      const currentIndex = ref(0);
      const startX = ref(0);
      const endX = ref(0);

      const { locale } = useI18n();

      const compareDateToNow = (date) => {
        const now = new Date();
        const activeUntil = parseDate(date)
        //add 5 days to activeUntil
        activeUntil.setDate(activeUntil.getDate() + 5);

        return activeUntil > now;
      };

      const cards = ref(props.cards?.length ? props.cards : [
        {
          header: 'internet',
          type: 'VIP HD',
          speed: 100,
          unit: 'Мбіт/с',
          cost: 340.0,
          activeUntil: '01.10.2024',
        },
        {
          header: 'internet',
          type: 'VIP HD',
          speed: 100,
          unit: 'Мбіт/с',
          cost: 340.0,
          activeUntil: '01.10.2024',
        },
      ]);

      function changeSlide(index) {
        currentIndex.value = index;
      }

      function startSwipe(event) {
        startX.value = event.touches[0].clientX;
      }

      function moveSwipe(event) {
        endX.value = event.touches[0].clientX;
      }

      function endSwipe() {
        const threshold = 50; // Мінімальна відстань для розпізнавання свайпу
        if (startX.value - endX.value > threshold && currentIndex.value < cards.value.length - 1) {
          // Свайп ліворуч
          currentIndex.value++;
        } else if (endX.value - startX.value > threshold && currentIndex.value > 0) {
          // Свайп праворуч
          currentIndex.value--;
        }
      }

      return {
        currentIndex,
        cards,
        changeSlide,
        startSwipe,
        moveSwipe,
        endSwipe,
        compareDateToNow,
        locale
      };
    },
  };
</script>

  <style scoped>
  .slider-container {
    width: 100%;
    overflow: hidden;
  }

  .tariff-block {
    display: flex;
    transition: transform 0.5s ease;
  }

  .tariff-card {
    min-width: 100%;
    flex-shrink: 0;
  }

  .navigation {
    display: flex;
    gap: 5px;
    justify-content: center;
    margin-top: -10px;
  }

  .navigation__square {
    width: 8px;
    height: 8px;
    background-color: #C7C8D1;
    cursor: pointer;
  }

  .navigation__square.open {
    width: 10px;
    height: 10px;
    background-color: #E0C522;
  }
</style>
